<section class="details">
  <p class="kicker">{{ lang.t('detKicker') }}</p>
  <h1>{{ lang.t('detH') }}</h1>
  <p>{{ lang.t('detP') }}</p>

  <form [formGroup]="form" (ngSubmit)="submit()">
    @if (serverError(); as message) {
      <p class="banner" role="alert">{{ message }}</p>
    }

    <div class="details-grid">
      <label>
        {{ lang.t('detAddress') }}
        <input type="text" formControlName="address" autocomplete="street-address" />
      </label>
      <label>
        {{ lang.t('detResidence') }}
        <select formControlName="residence">
          <option value="" disabled>{{ lang.t('upSelect') }}</option>
          @for (item of countries; track item.iso) {
            <option [value]="item.iso">{{ flag(item.iso) }} {{ item.name }}</option>
          }
        </select>
      </label>
      <label>
        {{ lang.t('detCity') }}
        <input type="text" formControlName="city" autocomplete="address-level2" />
      </label>
      <label>
        {{ lang.t('detZip') }}
        <input type="text" formControlName="postalCode" autocomplete="postal-code" />
      </label>
      <label>
        {{ lang.t('detNation') }}
        <select formControlName="nationality">
          <option value="" disabled>{{ lang.t('upSelect') }}</option>
          @for (item of countries; track item.iso) {
            <option [value]="item.iso">{{ flag(item.iso) }} {{ item.name }}</option>
          }
        </select>
      </label>
      <label>
        {{ lang.t('detBirth') }}
        <input type="text" formControlName="birth" inputmode="numeric" autocomplete="bday" placeholder="DD.MM.YYYY" maxlength="10" (input)="maskBirth($event)" />
        <small class="hint">{{ lang.t('detBirthHint') }}</small>
      </label>
    </div>

    @if (form.touched && form.invalid) {
      <p class="banner" role="alert">{{ form.controls.birth.invalid && form.controls.birth.touched ? lang.t('detBirthErr') : lang.t('detEmpty') }}</p>
    }

    <button class="btn primary" type="submit" [disabled]="submitting()">{{ submitting() ? lang.t('detBusy') : lang.t('detProceed') }}</button>
  </form>
</section>
